var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.searchData.results
    ? _c(
        "div",
        { staticClass: "g-searchspring__container" },
        [
          _c("cart-toast", { attrs: { results: _vm.searchData.results } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "g-searchspring__header" },
            [
              _c("banner", {
                attrs: {
                  merchandising: _vm.searchData.merchandising,
                  type: "header",
                },
              }),
              _vm._v(" "),
              _c("banner", {
                attrs: {
                  merchandising: _vm.searchData.merchandising,
                  type: "banner",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "g-searchspring__content g-layout g-layout--justify-center",
            },
            [
              _vm.searchData.results.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "g-searchspring__div g-layout__item u-width-12 u-width-3--l",
                      attrs: { id: "js-searchspring-facets" },
                    },
                    [
                      _c("facets", {
                        attrs: {
                          facets: _vm.searchData.facets,
                          filterSummary: _vm.searchData.filterSummary,
                          pagination: _vm.searchData.pagination,
                        },
                      }),
                      _vm._v(" "),
                      _c("banner", {
                        attrs: {
                          merchandising: _vm.searchData.merchandising,
                          type: "left",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.searchData.results.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "g-searchspring__results g-layout__item u-width-12 u-width-9--l",
                    },
                    [
                      _c("search-results", {
                        attrs: {
                          facets: _vm.searchData.facets,
                          filterSummary: _vm.searchData.filterSummary,
                          merchandising: _vm.searchData.merchandising,
                          pagination: _vm.searchData.pagination,
                          results: _vm.searchData.results,
                          sorting: _vm.searchData.sorting,
                        },
                      }),
                      _vm._v(" "),
                      _c("banner", {
                        attrs: {
                          merchandising: _vm.searchData.merchandising,
                          type: "footer",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "g-searchspring__results g-ntfd-wrapper g-layout__item u-width-12",
                      attrs: { id: "js-ntfd" },
                    },
                    [
                      _c("div", { staticClass: "g-ntfd-content" }, [
                        _c("div", { staticClass: "g-ntfd-search" }, [
                          _c("div", { staticClass: "g-ntfd-search__inner" }, [
                            (_vm.Screen = "CTGY")
                              ? _c(
                                  "div",
                                  { staticClass: "g-ntfd-search-header" },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "g-ntfd-search-header__title",
                                      },
                                      [_vm._v("Sorry, no matches were found.")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "g-ntfd-search-header__subtitle",
                                      },
                                      [
                                        _vm._v(
                                          "Try a new search or explore one of our suggestions."
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "g-ntfd-search-header" },
                                  [
                                    _c(
                                      "h1",
                                      {
                                        staticClass:
                                          "g-ntfd-search-header__title",
                                      },
                                      [_vm._v("Sorry, page not found.")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "g-ntfd-search-header__subtitle",
                                      },
                                      [
                                        _vm._v(
                                          "Try using our search or explore one of our suggestions."
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                staticClass: "g-ntfd-search-form",
                                attrs: { method: "get", action: _vm.SearchUrl },
                              },
                              [
                                _c("fieldset", [
                                  _c(
                                    "legend",
                                    { staticClass: "u-hide-visually" },
                                    [_vm._v("Product Search")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "g-form-list" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "g-form-list__item g-form-list__item--full g-control-group u-flex",
                                      },
                                      [
                                        (_vm.Screen = "CTGY")
                                          ? _c("input", {
                                              staticClass:
                                                "g-form-input g-control-group__field u-bg-transparent u-border-none g-ntfd-search-form__input",
                                              attrs: {
                                                type: "search",
                                                name: "Search",
                                                value: "",
                                                placeholder:
                                                  "Try Searching Again",
                                                autocomplete: "off",
                                                "aria-label":
                                                  "Try Searching Again",
                                                required: "",
                                              },
                                            })
                                          : _c("input", {
                                              staticClass:
                                                "g-form-input g-control-group__field u-bg-transparent u-border-none g-ntfd-search-form__input",
                                              attrs: {
                                                type: "search",
                                                name: "Search",
                                                value: "",
                                                placeholder: "Try Searching",
                                                autocomplete: "off",
                                                "aria-label": "Try Searching",
                                                required: "",
                                              },
                                            }),
                                        _vm._v(" "),
                                        _vm._m(0),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(1),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "g-ntfd-carousel" },
                          [
                            _c("x-ss-recommendations", {
                              attrs: {
                                title: "Items You May Like",
                                type: "MAY_LIKE",
                                tags: "no-results",
                                list: "Items You May Like",
                                limits: "20",
                                "carousel-options": JSON.stringify(
                                  _vm.ntfdCarouselOptions
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass:
          "g-button g-control-group__button u-bg-transparent u-icon-search u-border-none g-ntfd-search-form__button",
        attrs: { type: "submit" },
      },
      [_c("span", { staticClass: "u-hide-visually" }, [_vm._v("Search")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "g-ntfd-search-tips" }, [
      _c("p", { staticClass: "g-ntfd-search-tips__title" }, [
        _vm._v("Search Tips:"),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "g-ntfd-search-tips__list" }, [
        _c("li", { staticClass: "g-ntfd-search-tips__list-item" }, [
          _vm._v("Please double check your spelling."),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "g-ntfd-search-tips__list-item" }, [
          _vm._v(
            "Use more generic search terms (e.g. Football Jersey, baseball hat)."
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "g-ntfd-search-tips__list-item" }, [
          _vm._v(
            "Your product search may have been discontinued, removed, or is not yet on our site."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }